export const RPM_ALERT_PRIORITY = {
    "NORMAL": 0,
    "MODERATE": 5,
    "HIGH": 10
}


export const RPM_ALERT_RNAGES = {
    "NORMAL": {
        "min": 0,
        "max": 3
    },  
    "MODERATE": {
        "min": 3,
        "max": 5
    },
    "HIGH": {
        "min": 5,
        "max": 10
    }
}


export const VITAL_RANGES ={
    bglf: { min: 0, max: 1000 },
    bgpp: { min: 0, max: 1000 },
    bp: { min: 0, max: 300 },
    pr: { min: 0, max: 300 },
    bt: { min: 80, max: 110 },
    bmi: { min: 0, max: 100 },
    spo2: { min: 0, max: 100 }
};


export const VITAL_KEYWORDS = { 
    spo2: 'spO2', 
    BODY_TEMPERATURE: 'bt', 
    PULSE_RATE: 'pr',
    BMI: 'bmi', 
    BLOOD_PRESSURE: 'bp', 
    FASTING_BLOOD_GLUCOSE: 'bglf', 
    RANDM_BLOOD_GLUCOSE: 'bgpp'
}; 